/**
 * Build version baked into the JS bundle at compile time.
 *
 * IMPORTANT: bump this string with every frontend release alongside:
 *   /app/frontend/public/sw.js   (STATIC_CACHE / API_CACHE)
 *   /app/backend/utils/version.py   (APP_VERSION)
 *
 * The <VersionBanner /> component polls /api/version every 5 minutes and
 * shows a "New version available — tap to refresh" pill if the server's
 * version differs from this constant. Tapping the pill reloads the page so
 * the user picks up the new bundle without uninstalling their PWA.
 */

export const APP_VERSION = 'v272';
